import {
  Mountain,
  Factory,
  Wheat,
  HardHat,
  Trees,
  Recycle,
  Zap,
  Ship,
  Quote,
} from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import LogoCarousel from "../components/LogoCarousel";
import Seo from "../components/Seo";

const ICONS = [Mountain, Factory, Wheat, HardHat, Trees, Recycle, Zap, Ship];

const Clients = () => {
  const { t } = useLang();

  return (
    <div data-testid="clients-page">
      <Seo pageKey="clients" />
      {/* Hero */}
      <section className="border-b border-white/10 relative overflow-hidden">
        <div className="absolute inset-0 grid-bg opacity-25" />
        <div className="relative mx-auto max-w-[1400px] px-5 lg:px-10 pt-20 lg:pt-28 pb-16 lg:pb-24">
          <div className="flex items-center gap-3 mb-6">
            <span className="block w-10 h-px bg-[#FF4500]" />
            <span className="text-overline text-[#FF4500]">{t.clients.eyebrow}</span>
          </div>
          <h1
            data-testid="clients-title"
            className="font-display text-5xl sm:text-6xl lg:text-7xl uppercase leading-[0.9] text-white max-w-5xl whitespace-pre-line"
          >
            {t.clients.title}
          </h1>
          <p className="mt-8 text-white/70 max-w-3xl leading-relaxed">{t.clients.lead}</p>
        </div>
      </section>

      {/* Industries grid */}
      <section className="bg-[#050505]">
        <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-16 lg:py-24">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
            {t.clients.industries.map((c, i) => {
              const Icon = ICONS[i % ICONS.length];
              return (
                <div
                  key={c.t}
                  data-testid={`industry-${i}`}
                  className="bg-[#0a0a0a] p-7 hover:bg-[#0f0f0f] group transition-colors"
                >
                  <div className="flex items-start justify-between">
                    <span className="text-overline text-white/40">
                      0{i + 1}
                    </span>
                    <Icon className="w-6 h-6 text-[#FF4500] group-hover:scale-110 transition-transform" />
                  </div>
                  <h3 className="mt-8 font-display text-2xl uppercase text-white">{c.t}</h3>
                  <p className="mt-3 text-sm text-white/60 leading-relaxed">{c.d}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Logos carousel */}
      <LogoCarousel />

      {/* Testimonials */}
      <section className="border-t border-white/10 bg-[#0a0a0a]">
        <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-16 lg:py-24">
          <div className="flex items-center gap-3 mb-10">
            <span className="block w-10 h-px bg-[#FF4500]" />
            <span className="text-overline text-[#FF4500]">{t.clients.testimonialTitle}</span>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
            {t.clients.testimonials.map((tm, i) => (
              <div
                key={tm.a}
                data-testid={`testimonial-${i}`}
                className="p-8 border border-white/10 bg-[#050505] flex flex-col"
              >
                <Quote className="w-8 h-8 text-[#FF4500]" />
                <p className="mt-6 text-white text-lg leading-relaxed">&ldquo;{tm.q}&rdquo;</p>
                <div className="mt-6 pt-6 border-t border-white/10 text-overline text-white/50">
                  {tm.a}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Clients;
